'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../styleInject.js');

var css_248z = ".PackageAdditionalInfoForm-module_textarea__TjPvC{display:flex;min-height:200px;width:100%}";
var styles = {"textarea":"PackageAdditionalInfoForm-module_textarea__TjPvC"};
styleInject["default"](css_248z, '778afcf6-6513-47fc-8b5e-38e6785d5f4b');

exports["default"] = styles;
